export const ASTRA_STATUS = {
  ACTIVE: 'active',
  SUSPENDED: 'suspended'
};

export const CARD_TYPE = {
  DEBIT: 'debit',
  CREDIT: 'credit'
};

export const CARD_STATUS = {
  APPROVED: 'approved'
};

// The maximum number of astra cards that can be added
export const ACTIVE_CARD_LIMIT = 3;

// Astra card types https://docs.astra.finance/reference/get_v1-cards-id
export const ASTRA_CARD_TYPE = {
  DEBIT: 'debit',
  PREPAID: 'prepaid',
  CREDIT: 'credit',
  UNKNOWN: 'unknown'
};

// Astra card status https://docs.astra.finance/reference/card-review-statuses#card-statuses
export const ASTRA_CARD_STATUS = {
  APPROVED: 'approved',
  FLAGGED: 'flagged',
  REJECTED: 'rejected',
  REMOVED: 'removed',
  PENDING: 'pending'
};

// Astra document review status https://docs.astra.finance/reference/card-review-statuses#review-statuses
export const ASTRA_CARD_REVIEW_STATUS = {
  APPROVED: 'approved',
  FLAGGED: 'flagged',
  REJECTED: 'rejected',
  UNREVIEWED: 'unreviewed'
};

export const ID_THEFT_SCORE = {
  CUTOFF_LIMIT: 500,
  MAX_SCORE: 1000
};
